
import {View} from "backbone";
import template from 'dashboard/connections/connection-general-view.ejs'
import $ from 'jquery';

class ConnectionGeneralView extends View {
    initialize(opts){

        this.template = template;
        this.connectionService = opts.connectionService;

        this.events = {
            'keyup input[name=Name]':'changeConnectionName',
            'change input[name=IsActive]':'changeConnectionStatus',
            'change select[name="permissions"]':'updatePermissions'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    changeConnectionName(){
        return this.connectionService.changeConnectionName.apply(this.connectionService, arguments);
    }

    changeConnectionStatus(){
        return this.connectionService.changeConnectionStatus.apply(this.connectionService, arguments);
    }

    render(){
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.$el.css('cursor', 'default');

        $('input[name="Name"]').trigger('focus').val("").val(this.model.get('currentConnectionDetails').Name);

        this.delegateEvents();
        return this;
    }

}

export default ConnectionGeneralView;